import AboutContent from '../components/websiteComponents/AboutContent';

const About = () => {
  return <AboutContent />;
};

export default About;
